import { createApp } from 'vue'
import vuetify from './plugins/vuetify'
import i18n from '@/plugins/i18n'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { installComponents } from './plugins/global-components'
import mitt from 'mitt'
import '@/assets/main.css'

const app = createApp(App)

const emitter = mitt()
app.provide('emitter', emitter)

app.use(vuetify)
app.use(createPinia())
app.use(router)
app.use(i18n)

installComponents(app)


app.mount('#app')

export { vuetify }
